import { JobProps } from "utils/types";
import React, {FC, useState} from "react";
import {Button} from "@material-ui/core";
import styles from "../ShiftDetail.module.scss";
import {exitReact} from "../../../../utils";
import useActionApi from "../../../../hooks/useActionApi";
import Api from "../../../../api";
import FixedLoader from "components/FixedLoader/FixedLoader";
import clsx from "clsx";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import {JOB_STATUSES} from "../ShiftDetailPage";
import {ShiftPopup} from "./index";
import Popup from "../../../../components/Popup";


// @ts-ignore
const TempStars = window.TempStars

const ResubmitShiftModal:FC<{
    job: JobProps,
    history: any,
    trackData: any,
    expiredOfferId: number,
}> = (
    {
        job,
        history,
        trackData,
        expiredOfferId,
    }) => {
    const [isOpenResubmitShiftModal, setIsOpenResubmitShiftModal] = useState<boolean>(false);

    const [resubmitJobLoading, , resubmitOffer] = useActionApi({
        apiMethod: Api.resubmitOffer,
        onSuccess: () => {
            TempStars.Analytics.track( 'resubmitted shift', trackData );
            history.push('loading')
            ;(window as any).TempStars?.App?.goReact('hygienistHome')
        }
    });

    const onResubmitShift = async () => {
        setIsOpenResubmitShiftModal(false)
        await resubmitOffer(expiredOfferId)
    }

    return (JOB_STATUSES.OFFER_EXPIRED === job.status && expiredOfferId ? <>
        <Popup opened={isOpenResubmitShiftModal} onClose={() => setIsOpenResubmitShiftModal(false)}>
            <ShiftPopup
                title={'Resubmit offer'}
                submit={'Resubmit'}
                close={'Cancel'}
                job={job}
                onClose={() => setIsOpenResubmitShiftModal(false)}
                onSubmit={onResubmitShift}
            />
        </Popup>

        <Button
            className={clsx(styles.statusButton, styles.resubmitShift)}
            onClick={() => setIsOpenResubmitShiftModal(true)}
        >
            <EventAvailableIcon className={styles.confirmedShiftIcon}/>
            Resubmit Offer
        </Button>

        <FixedLoader
            loading={resubmitJobLoading}
        />
    </> : null)
}

export default ResubmitShiftModal;